"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Label = exports.EmptyLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LabelWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "TooltipLabel__LabelWrapper",
  componentId: "bufferapp-ui__sc-1eztsij-0"
})(["display:flex;align-items:center;align-content:center;font-size:13px;height:14px;line-height:14px;width:100%;max-width:160px;padding-top:4px;padding-bottom:4px;"]);
const Label = exports.Label = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "TooltipLabel__Label",
  componentId: "bufferapp-ui__sc-1eztsij-1"
})(["width:127px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-left:", ";"], props => props.hasIcon ? '7px' : 0);
const EmptyLabel = exports.EmptyLabel = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "TooltipLabel__EmptyLabel",
  componentId: "bufferapp-ui__sc-1eztsij-2"
})(["white-space:break-spaces;padding-top:50px;padding-bottom:50px;height:auto;"]);
const TooltipLabel = _ref => {
  let {
    items,
    maxItems,
    defaultMessage
  } = _ref;
  if (!items && !defaultMessage) return null;
  const totalItems = items.length;
  const exceedsTotal = totalItems > maxItems;
  const remainingItems = totalItems - maxItems;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, items.slice(0, maxItems).map((item, index) => ( /*#__PURE__*/_react.default.createElement(LabelWrapper, {
    key: `tooltip-item-${index}`
  }, item.icon, /*#__PURE__*/_react.default.createElement(Label, {
    hasIcon: true
  }, item.title)))), items.length === 0 && ( /*#__PURE__*/_react.default.createElement(LabelWrapper, null, /*#__PURE__*/_react.default.createElement(EmptyLabel, null, defaultMessage))), exceedsTotal && ( /*#__PURE__*/_react.default.createElement(LabelWrapper, null, /*#__PURE__*/_react.default.createElement(Label, null, `Plus ${remainingItems} more...`))));
};
TooltipLabel.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    icon: _propTypes.default.node
  })),
  defaultMessage: _propTypes.default.string
};
TooltipLabel.defaultProps = {
  items: [],
  defaultMessage: null
};
var _default = exports.default = TooltipLabel;